import script from "./DesktopOnlyNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopOnlyNotice.vue?vue&type=script&setup=true&lang=js"

import "./DesktopOnlyNotice.vue?vue&type=style&index=0&id=014488d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014488d2"]])

export default __exports__